import { AppContextService } from '../../services/app-context.service';
import { Subscription } from 'rxjs';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Optional, Output, ViewChild } from '@angular/core';

import { WorkspaceBreadcrumb } from './workspace-breadcrumbs.component';

/** Shared chrome for every routed business page. */
@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.css'],
})
export class WorkspaceComponent implements AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('body') body?: ElementRef<HTMLElement>;
  private registration?: Subscription;
  private pendingScroll: { position: number; version: number | undefined } | null = null;
  constructor(@Optional() private readonly context?: AppContextService) {}
  ngAfterViewInit(): void {
    this.registration = this.context?.registerView({ key: 'workspace-scroll', name: 'Workspace scroll',
      read: () => this.body?.nativeElement.scrollTop ?? 0, describe: () => null,
      restore: position => { this.pendingScroll = { position, version: this.context?.restorationVersion }; },
    });
  }
  ngAfterViewChecked(): void {
    if (this.pendingScroll?.version !== this.context?.restorationVersion) this.pendingScroll = null;
    const body = this.body?.nativeElement;
    if (body && this.pendingScroll !== null && body.scrollHeight - body.clientHeight >= this.pendingScroll.position) {
      body.scrollTop = this.pendingScroll.position;
      this.pendingScroll = null;
    }
  }
  cancelScrollRestore(): void { this.pendingScroll = null; }
  ngOnDestroy(): void { this.registration?.unsubscribe(); }

  @Input() open = false;
  @Input() canBack = false;
  @Input() canForward = false;
  @Output() backRequested = new EventEmitter<void>();
  @Output() forwardRequested = new EventEmitter<void>();
  @Input() breadcrumbs: WorkspaceBreadcrumb[] = [];
  @Input() maximized = false;
  @Input() dockedRight = false;

  @Output() dockRightRequested = new EventEmitter<void>();
  @Output() maximizeRequested = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();
}
